<template>
  <div>
    <v-row class="px-3">

      <!-- Machine Stop Block -->
      <v-col cols="12" class="grey lighten-4 round-corners">
        <v-row no-gutters>
          <v-col cols="6" class="font-weight-bold">
            Bloques de parada de máquina
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn small color="primary" @click="show()" v-if="isEditing">Añadir</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <!-- Table -->
      <v-col cols="12">
        <v-data-table
          :headers="filteredHeaders"
          :items="list"
          class="elevation-0"
          :loading="loadingData"
        >
          <!-- Actions -->
          <template v-slot:item.action="{ item }">
            <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon @click="show('delete', item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      width="450px"
    >
      <v-card v-if="dialog">
        <v-card-title primary-title>
          {{ isNew }} bloque de parada de maquina
        </v-card-title>
        <v-card-text>
          <v-row justify="space-between">
            <!-- AG -->
            <v-col cols="6">
              <v-text-field
                v-model="item.wind_turbine"
                :error-messages="windTurbineErrors"
                label="AG"
                maxlength="10"
                counter="10"
                @blur="$v.item.wind_turbine.$touch()"
              ></v-text-field>
            </v-col>
            <!-- Responsable -->
            <v-col cols="6">
              <v-select
                v-model="item.stopped_by"
                :error-messages="stopByErrors"
                :items="options"
                label="Responsable"
                @blur="$v.item.stopped_by.$touch()"
              ></v-select>
            </v-col>
            <!-- Time Stop -->
            <v-col cols="6">
              <v-menu
                ref="machine_stop_block_stop"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="item.stop_time"
                    :error-messages="timeStopErrors"
                    label="Hora parada"
                    readonly
                    v-on="on"
                    @click="$v.item.stop_time.$touch()"
                  ></v-text-field>
                </template>
              <v-time-picker
                v-if="menu1"
                v-model="item.stop_time"
                :max="item.start_time"
                full-width
                format="24hr"
                @click:minute="$refs.machine_stop_block_stop.save(item.stop_time)"
              ></v-time-picker>
              </v-menu>
            </v-col>
            <!-- Time Start -->
            <v-col cols="6">
              <v-menu
                ref="machine_stop_block_start"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="item.start_time"
                    :error-messages="timeStartErrors"
                    label="Hora arranque"
                    readonly
                    v-on="on"
                    @click="$v.item.start_time.$touch()"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu2"
                  v-model="item.start_time"
                  :min="item.stop_time"
                  full-width
                  format="24hr"
                  @click:minute="$refs.machine_stop_block_start.save(item.start_time)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <v-btn text class="mr-4" @click="close()">Cancelar</v-btn>
          <v-btn color="primary" :disabled="invalid" @click="save()">{{ isNew }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Confirmation -->
    <confirmation
      v-model="deleteDialog"
      title="Eliminar bloque de parada de máquina"
      text="Desea eliminar el bloque de parada de máquina"
      @close="close('delete')"
      @confirm="deleteItem()"
    />
  </div>
</template>

<script>
import Confirmation from "@/components/Confirmation";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Util from "@/util/index";

export default {
  name: 'machine-stop-block',
  props: {
    isEditing: Boolean,
    day: { type: Object, default: () => {} }
  },
  components: {
    Confirmation
  },
  mixins: [validationMixin],
  validations: {
    item: {
      wind_turbine: { required },
      stop_time: { required },
      start_time: { required },
      stopped_by: { required },
    },
  },
  data: () => ({
    index: -1,
    dialog: false,
    deleteDialog: false,
    menu1: false,
    menu2: false,
    loadingData: false,
    item: {},
    options: ['Galventus', 'Cliente'],
    headers: [
      { text: "AG", value: "wind_turbine", align: "center" },
      { text: "Hora parada", value: "stop_time", align: "center" },
      { text: "Hora arranque ", value: "start_time", align: "center" },
      { text: "Responsable", value: "stopped_by", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
  }),
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return this.index > -1 ? 'Modificar' : 'Añadir'
    },
    invalid () {
      return this.$v.$invalid && this.$v.$dirty
    },
    list () {
      return this.$store.state.interventions.shutDownBlocks.list
        .filter(element => element.work_intervention_day_id === this.day.id)
    },
    filteredHeaders () {
      return this.headers.filter(element => this.isEditing && element.value === 'action' || element.value !== 'action')
    },
    windTurbineErrors () {
      const errors = []
      if (!this.$v.item.wind_turbine.$dirty) return errors
      !this.$v.item.wind_turbine.required && errors.push('Obligatorio.')
      return errors
    },
    timeStopErrors () {
      const errors = []
      if (!this.$v.item.stop_time.$dirty) return errors
      !this.$v.item.stop_time.required && errors.push('Obligatorio.')
      return errors
    },
    timeStartErrors () {
      const errors = []
      if (!this.$v.item.start_time.$dirty) return errors
      !this.$v.item.start_time.required && errors.push('Obligatorio.')
      return errors
    },
    stopByErrors () {
      const errors = []
      if (!this.$v.item.stopped_by.$dirty) return errors
      !this.$v.item.stopped_by.required && errors.push('Obligatorio.')
      return errors
    },
  },
  methods: {
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = `Ha ocurrido un error ${altText}`
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
    init() {
      if (this.day.id) {
        this.loadingData = true
        const body = {
          id: this.day.id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'windTurbineShutdownBlocks'
        }
        this.$store.dispatch('interventions/shutDownBlocks/list', body)
          .catch(error => {
            let altText = "cargando la lista de bloques de parada de máquina."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loadingData = false
          })
      }
    },
    show (dialog, item) {
      if (dialog === 'delete') {
        this.item = item
        this.deleteDialog = true
      } else {
        this.dialog = true
      }
    },
    close (dialog) {
      if (dialog === 'delete') {
        this.deleteDialog = false
      } else {
        this.dialog = false
        this.index = -1
        this.$emit('close', this.list)
      }
      this.item = {}
      this.$v.$reset()
    },
    editItem (item) {
      this.index = this.list.indexOf(item)
      this.item = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem () {
      this.loading = true
      this.$store.dispatch('interventions/shutDownBlocks/delete', this.item.id)
        .then(() => {
          this.$toast("Bloque de parada de maquina eliminado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
        })
        .catch(error => {
          let altText = "eliminando el bloque de parada de maquina."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
      this.close('delete')
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        const body = {
          ...this.item,
          started_by: this.item.stopped_by
        }
        if (!body.work_intervention_id) body.work_intervention_id = this.$route.params.id
        if (!body.work_intervention_day_id) body.work_intervention_day_id = this.day.id
        this.index > -1
          ? this.$store.dispatch('interventions/shutDownBlocks/edit', this.item)
            .then(() => {
              this.$toast("Bloque de parada de maquina modificado correctamente.", {
                color: "success",
                x: "center",
                y: "top",
                icon: "mdi-information"
              });
              this.init()
            })
            .catch(error => {
              let altText = "Ha ocurrido un error modificando el bloque de parada de maquina."
              this.errorAlert(error, altText)
            })
            .finally(() => {
              this.loading = false
            })
          : this.$store.dispatch('interventions/shutDownBlocks/create', body)
            .then(() => {
              this.$toast("Bloque de parada de maquina creado correctamente.", {
                color: "success",
                x: "center",
                y: "top",
                icon: "mdi-information"
              });
              this.init()
            })
            .catch(error => {
              let altText = "Ha ocurrido un error creado el bloque de parada de maquina."
              this.errorAlert(error, altText)
            })
            .finally(() => {
              this.loading = false
            })
        this.close()
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
